import React from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from '@carvana/showroom-spinner';
import {
  TransactionHistoryContentWrapper,
  TransactionHistoryWrapper,
  SpinnerWrapper,
} from './TransactionHistory.styles';
import BackLink from '../future-packages/back-link';
import MyCarsRefreshHook from '../../utils/MyCarsRefreshHook';
import TransactionHistoryList from './transaction-history-list/TransactionHistoryList';

const TransactionHistory = () => {
  const { id }: any = useParams();

  // Refresh Hook - Avoid selectors/ redux state access before the refresh hook and loader
  const isLoading = MyCarsRefreshHook(id);
  if (isLoading) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );
  }

  return (
    <TransactionHistoryWrapper>
      <TransactionHistoryContentWrapper>
        <BackLink
          backLinkTrackEvent="CLTV-OEM-Back-To-My-Cars-Loan-Details"
          backLinkText="Back to Loan Details"
          backLinkRoute={`/loan-detail/${id}`}
        />
        <TransactionHistoryList />
      </TransactionHistoryContentWrapper>
    </TransactionHistoryWrapper>
  );
};

export default TransactionHistory;
